module.exports = __webpack_public_path__ + "static/13-1-ef28a6e7763badcabe38cbe074d18bc7.jpg";